<script>
  // Header component logic can be added here if needed
</script>

<div class="header-container">
  <div class="header-bar">
    <div class="logo-center">
      <a href="https://www.businesstimes.com.sg" target="_blank" rel="noopener noreferrer">
        <img src="./images/bt_logo_black.png" alt="The Business Times" class="btlogo-img" />
      </a>
    </div>
    <div class="share-container">
      <div class="shareon">
        <a class="facebook" href="https://www.facebook.com/thebusinesstimes/" rel="noopener noreferrer" target="_blank" aria-label="Visit The Business Times on Facebook">
          <span class="sr-only">Visit The Business Times on Facebook</span>
        </a>
        <a class="twitter" href="https://x.com/BusinessTimes" rel="noopener noreferrer" target="_blank" aria-label="Visit The Business Times on X">
          <span class="sr-only">Visit The Business Times on X</span>
        </a>
        <a class="instagram" href="https://www.instagram.com/businesstimessg/?hl=en" rel="noopener noreferrer" target="_blank" aria-label="Visit The Business Times on Instagram">
          <span class="sr-only">Visit The Business Times on Instagram</span>
        </a>
        <a class="linkedin" href="https://linkedin.com/company/the-business-times" rel="noopener noreferrer" target="_blank" aria-label="Visit The Business Times on LinkedIn">
          <span class="sr-only">Visit The Business Times on LinkedIn</span>
        </a>
      </div>
    </div>
  </div>
</div>

<style>
  /* Header styles */
  .header-container {
    /* position: fixed; */
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
  }

  .header-bar {
    display: flex;
    padding: 10px 20px;
    backdrop-filter: blur(5px);
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: #EFF8F3;
  }

  .logo-center {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
  }

  .btlogo-img {
    display: block;
    max-height: 22px;
    width: auto;
    margin: 0 auto;
    padding: 4px 16px;
  }

  .share-container {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
  }

  .logos-container,
  .header-bar .btlogo {
    display: none;
  }

  .shareon {
    display: flex;
    gap: 10px;
  }

  .shareon a {
    position: relative; /* Important for absolute positioning of pseudo-elements */
    width: 22px;
    height: 22px;
    display: block;
    cursor: pointer;
    z-index: 1;
  }

  .shareon>.facebook:before {
    content: ""; /* Required for the pseudo-element to show */
    position: absolute; /* Required for top/left to work */
    background-image: url('/images/fb.png') !important;
    width: 22px;
    height: 22px;
    background-size: 22px;
    background-repeat: no-repeat; /* Prevent tiling */
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none; /* Allow clicks to pass through to the link */
  }

  .shareon>.twitter:before {
    content: "";
    position: absolute;
    background-image: url('/images/x.png') !important;
    width: 22px;
    height: 22px;
    background-size: 22px;
    background-repeat: no-repeat;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none; /* Allow clicks to pass through to the link */
  }

  .shareon>.instagram:before {
    content: "";
    position: absolute;
    background-image: url('/images/ig.png') !important;
    width: 22px;
    height: 22px;
    background-size: 22px;
    background-repeat: no-repeat;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none; /* Allow clicks to pass through to the link */
  }

  .shareon>.linkedin:before {
    content: "";
    position: absolute;
    background-image: url('/images/linkedin.png') !important;
    width: 22px;
    height: 22px;
    background-size: 22px;
    background-repeat: no-repeat;
    top: 0;
    left: 0;
    pointer-events: none; /* Allow clicks to pass through to the link */
  }

  .header-bar .btlogo {
    width: 250px;
    height: 24px;
    cursor: pointer;
    background-image: url(https://www.businesstimes.com.sg/bt_files/interactives/assets/btLogo.png) !important;
    background-size: contain;
    background-color: transparent;
    background-repeat: no-repeat;
    border: none;
    margin: 0;
    padding: 0
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  @media (min-width: 175px) and (max-width: 815px) {
    .header-bar .btlogo {
      width: 30px;
      background-image: url(https://www.businesstimes.com.sg/bt_files/interactives/assets/btMobileLogo.png) !important
    }
  }

  @media (max-width: 768px) {
    .share-container {
      display: none;
    }
  }
</style>
